import { useSearch } from "@tanstack/react-router";

import { ResultDetailForm } from "../components/results/ResultDetailForm";
import { Section } from "../components/Section";

export function NewResultPage() {
  const search = useSearch({ strict: false }) as { category?: string };
  const category = search.category || "TEXT";
  const isOrganism = category === "ORGANISM";

  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>
        {isOrganism ? "New organism" : "New test result"}
      </Section.Title>
      <ResultDetailForm category={category} />
    </div>
  );
}
